import { IntermediateWrapper } from './index.styles';

const TableError = ({ height }: { height?: number }) => (
  <IntermediateWrapper height={height}>
    Error loading messages. Please try again later.
  </IntermediateWrapper>
);

export default TableError;
